import {useState} from "react";
import {Box, Button, MenuItem, Slider, TextField, Typography} from "@mui/material";
import {ElevationApp} from "../../ElevationApp";
import {MdFrameProfileType} from "../../model/frame/MdFrameSpec";
import {FrameGridScene} from "../../scenes/frameGrid/FrameGridScene";
import {allHandings} from "../../../../quote/openings/QuoteOpenings";
import {inches} from "../../const";
import {supportedProfiles} from "./FrameProfileCtrls";

export function FrameGridCtrls(props: {
    app: ElevationApp
}) {
    const spec = props.app.frameSpec;

    const [profile, setProfile] = useState<MdFrameProfileType>(spec?.profile || "STD");
    const [handing, setHanding] = useState<string>(spec?.handing || "");
    const [nominalWidthIn, setNominalWidthIn] = useState<number>(Math.round((spec?.nominalWidth.get() ?? 30 * inches) / inches));

    const apply = () => {
        const elev = props.app;

        elev.frameSpec.profile = profile;
        elev.frameSpec.handing = handing;
        elev.frameSpec.nominalWidth.userSet(nominalWidthIn * inches, {debug: "FrameGridCtrls nominalWidth"});

        elev.draw.showScene(new FrameGridScene(elev));
    };

    return (
        <>
            <TextField
                select
                size="small"
                label="Frame Profile"
                value={profile}
                onChange={e => setProfile(e.target.value as MdFrameProfileType)}
            >
                {supportedProfiles.map(p => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
            </TextField>

            <TextField
                select
                size="small"
                label="Handing"
                value={handing}
                onChange={e => setHanding(e.target.value)}
            >
                <MenuItem value="">(none)</MenuItem>
                {allHandings.map(h => (
                    <MenuItem key={h.value} value={h.value}>{h.display}</MenuItem>
                ))}
            </TextField>

            <Box sx={{minWidth: 180}}>
                <Typography variant="caption" color="textSecondary">
                    Nominal Width: {nominalWidthIn}"
                </Typography>
                <Slider
                    size="small"
                    min={30}
                    max={70}
                    step={1}
                    valueLabelDisplay="auto"
                    valueLabelFormat={v => `${v}"`}
                    value={nominalWidthIn}
                    onChange={(e, v) => setNominalWidthIn(v as number)}
                />
            </Box>

            <Button variant="contained" size="small" onClick={apply}>Apply</Button>
        </>
    );
}
